<template>
  <div class="content-item">
    <h2 class="heading">Website (Optional)</h2>
    <p class="text">This will be listed on the card</p>
    <div class="form-group">
      <input v-model="website" type="text" class="form-input" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step8',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      website: '',
    };
  },
  methods: {
    submit() {
      this.$emit('input', {
        ...this.value,
        website: this.website,
      });
    },
  },
};
</script>
